import { makeAutoObservable, observable } from "mobx";
import { AppModalTransferProps } from "@xt/Transfer";
import { AppModalBorrowRepayProps } from "components/Pages/assets/wallet/accType/_cmpt/modal/borrowRepay";
import { FaEnableAlertProps } from "components/Pages/assets/wallet/accType/_cmpt/modal/faEnableAlert";

interface StateProps {
  modalTransfer: WithUndefined<AppModalTransferProps>;
  modalBorrowRepay: WithUndefined<AppModalBorrowRepayProps>;
  modalFaEnableAlert: WithUndefined<FaEnableAlertProps>;
}

const argument = makeAutoObservable(
  {
    modalTransfer: undefined as StateProps["modalTransfer"], //划转对话框
    modalBorrowRepay: undefined as StateProps["modalBorrowRepay"], //划转对话框
    modalFaEnableAlert: undefined as StateProps["modalFaEnableAlert"], //2fa验证项启用对话框
    //
    updateState(payload: Partial<StateProps>) {
      for (const va in payload) {
        this[va] = payload[va];
      }
    },
    //
  },
  {},
  {
    autoBind: true,
    deep: false,
  }
);

export default argument;
